import { Carousel } from "flowbite-react";
import Image from "next/image";
import { useCarouselImages } from "../libs/hooks/useCarouselImages";
import { appConfig } from "../libs/appConfig";

type MainCarouselProps = {
  slideInterval?: number;
  showDecorativeCorners?: boolean;
};

export const MainCarousel: React.FC<MainCarouselProps> = ({
  slideInterval = 3000,
  showDecorativeCorners = true,
}) => {
  const { images, isLoading } = useCarouselImages();

  if (isLoading || images.length === 0) {
    return (
      <div className="h-[500px] md:w-[600px] w-full p-6">
        <div className="relative h-full w-full">
          <div className="h-full w-full bg-gray-200 animate-pulse rounded-lg" />
          {showDecorativeCorners && (
            <>
              <div className="absolute -top-2 -left-2 w-12 h-12 border-l-2 border-t-2 border-vintage-ochre/40 hidden lg:block" />
              <div className="absolute -bottom-2 -right-2 w-12 h-12 border-r-2 border-b-2 border-vintage-ochre/40 hidden lg:block" />
            </>
          )}
        </div>
      </div>
    );
  }

  return (
    <div className="h-[500px] md:w-[600px] w-full p-6">
      <div className="relative h-full w-full">
        <div className="relative h-full w-full rounded-lg overflow-hidden shadow-xl">
          <Carousel
            slideInterval={slideInterval}
            aria-label="Gallery"
            id="main-carousel"
          >
            {images.map((item, index) => {
              const imageData = item.attributes.image.data?.attributes;
              if (!imageData) return null;

              const imageUrl = imageData.url.startsWith("/")
                ? `${appConfig.assetsUrl}${imageData.url}`
                : imageData.url;

              return (
                <div key={item.id} className="relative w-full h-full">
                  <Image
                    src={imageUrl}
                    fill
                    className="object-cover"
                    alt={item.attributes.altText}
                    priority={index < 2}
                    sizes="(max-width: 768px) 100vw, 600px"
                  />
                </div>
              );
            })}
          </Carousel>
        </div>
        {showDecorativeCorners && (
          <>
            <div className="absolute -top-2 -left-2 w-12 h-12 border-l-2 border-t-2 border-vintage-ochre/40 hidden lg:block" />
            <div className="absolute -bottom-2 -right-2 w-12 h-12 border-r-2 border-b-2 border-vintage-ochre/40 hidden lg:block" />
          </>
        )}
      </div>
    </div>
  );
};
